import axios from "axios";
import ProviderDTO from "@/models/ProviderDTO";
import ProviderNameConfigDTO from "@/models/ProviderNameConfigDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import ProviderRequestDTO from "@/models/ProviderRequestDTO";
import PaginationDTO from "@/models/PaginationDTO";
import ProviderInvoiceDiffItemDTO from "@/models/ProviderInvoiceDiffItemDTO";
import SettingsHistoryItemDTO from "@/models/SettingsHistoryItemDTO";
import qs from "qs";

export const providers = {
    list: async (pagination: PaginationDTO, requestDTO: any = {}): Promise<PaginatedResponseDTO<ProviderDTO>> => {
        let resp = await axios({
            url: `/providers`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...requestDTO,
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<ProviderDTO>
    },
    all: async (): Promise<ProviderDTO[]> => {
        let resp = await axios({
            url: `/providers/all`,
            method: 'GET'
        });

        return resp.data as ProviderDTO[]
    },
    stats: async (): Promise<any> => {
        let resp = await axios({
            url: `/providers/stats`,
            method: 'GET'
        });

        return resp.data as any
    },
    invoiceDiff: async (id: number, pagination: PaginationDTO, requestDTO: any = {}): Promise<PaginatedResponseDTO<ProviderInvoiceDiffItemDTO>> => {
        let resp = await axios({
            url: `/providers/${id}/invoice-diff`,
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...requestDTO
            },
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            method: 'POST',
        });

        return resp.data as PaginatedResponseDTO<ProviderInvoiceDiffItemDTO>
    },
    reportCheckUpload: async (id: number, form: any): Promise<any> => {
        const formData = new FormData();
        for (const i in form) {
            formData.append(i, form[i] ?? '')
        }

        let resp = await axios({
            url: `/providers/${id}/report-check-upload`,
            data: formData,
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return resp.data as any;
    },
    requests: async (id: number, pagination: PaginationDTO, requestDTO: any = {}): Promise<PaginatedResponseDTO<ProviderRequestDTO>> => {
        let resp = await axios({
            url: `/providers/${id}/requests`,
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...requestDTO
            },
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            method: 'POST',
        });

        return resp.data as PaginatedResponseDTO<ProviderRequestDTO>
    },
    requestsByInvoice: async (id: string): Promise<ProviderRequestDTO[]> => {
        let resp = await axios({
            url: `/providers/requests/${id}`,
            method: 'GET',
        });

        return resp.data as ProviderRequestDTO[]
    },
    configs: async (): Promise<ProviderNameConfigDTO[]> => {
        let resp = await axios({
            url: `/providers/configs`,
            method: 'GET'
        });

        return resp.data as ProviderNameConfigDTO[]
    },
    update: async (id: number, data: any): Promise<void> => {
        let resp = await axios({
            url: `/providers/${id}`,
            method: 'PUT',
            data: {
                ...data
            }
        });
    },
    create: async (data: any): Promise<void> => {
        let resp = await axios({
            url: `/providers`,
            method: 'POST',
            data: {
                ...data
            }
        });
    },
    history: async (id: number, pagination: PaginationDTO): Promise<PaginatedResponseDTO<SettingsHistoryItemDTO>> => {
        let resp = await axios({
            url: `/providers/${id}/history`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
        });

        return resp.data as PaginatedResponseDTO<SettingsHistoryItemDTO>
    },
}
